import Swiper from "swiper";
import { Grid } from 'swiper/modules';
import { $Qll } from '../utils/query-selector';
import 'swiper/css/bundle';

const initProductsSwiper = () => {
  const swipers = $Qll('.jolly-products-blocks__mobile, .jolly-products-blocks__desktop');
  if (!swipers.length) return;

  swipers.forEach((container) => {
    const init = container.getAttribute('init-swiper');
    if (!init) return;

    new Swiper(container, {
      modules: [Grid],
      slidesPerView: 1.3,
      breakpoints: {
        320: {
          slidesPerView: 1.3
        },
        768: {
          slidesPerView: 2.3
        },
        992: {
          slidesPerView: 3.2
        }
      },
      spaceBetween: 16,
      grid: {
        rows: 1,
      }
    });
  });
};

export default initProductsSwiper;
